export enum Politesse {
    Tutoiement = 'tutoiement',
    VouvoiementFirstName = 'vouvoiement_firstname',
    VouvoiementLastName = 'vouvoiement_lastname',
}
